"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 4H2v16h20zM4 6h1v12H4zm16 12h-1V6h1z"
}), 'WidthFullSharp');